import type { ErrorResponse } from '~/types/error-responses.types';
import BaseException from './BaseException';

export default class NetworkException extends BaseException {
  readonly name = 'NetworkException';

  constructor(response?: ErrorResponse<any>) {
    super({
      errors: [
        {
          description: 'web.error.network_error',
        },
      ],
      ...response,
    });
  }
}
